import Typography from '../../Atoms/Typography';
import fileIcon from '../../../assets/images/Folder/file.svg';
import downloadfileIcon from '../../../assets/images/Folder/download.svg';
import openfileIcon from '../../../assets/images/Folder/open.svg';
import ReactTooltip from 'react-tooltip';

function FileName({ folder, downloadArtefactLink }) {
  return (
    <div className="ltw-flex ltw-items-center ltw-justify-between artefact-file-row">
      <ReactTooltip id="artefact-modal" html={true} />
      <div className="ltw-flex ltw-items-center ltw-gap-8px ltw-p-5px">
        <img src={fileIcon} width="16" height="16" alt="folder" />
        <Typography variant="h2" fontType="ltw-font-normal">
          {folder.name}
        </Typography>
      </div>
      <div className="ltw-flex ltw-items-center ltw-gap-10px artefact-hover-action ltw-mr-4px ltw-flex-shrink-0">
        <div
          onClick={() => downloadArtefactLink(folder, 'download')}
          onKeyDown={(e) => {}}
          role="button"
          tabIndex="0"
          data-tip="Download"
          data-for="artefact-modal"
        >
          <img src={downloadfileIcon} width="13" height="13" alt="download" />
        </div>
        <div
          onClick={() => downloadArtefactLink(folder, 'open')}
          onKeyDown={(e) => {}}
          role="button"
          tabIndex="0"
          data-tip="Open"
          data-for="artefact-modal"
        >
          <img src={openfileIcon} width="13" height="13" alt="open" />
        </div>
      </div>
    </div>
  );
}
export default FileName;
